import { render, staticRenderFns } from "./FreeformSelect.vue?vue&type=template&id=bd5f32f6"
import script from "./FreeformSelect.vue?vue&type=script&lang=js"
export * from "./FreeformSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports